import DashboardHeroImage from './DashboardHeroImage';

export default DashboardHeroImage;
